import { ReactNode } from 'react';
import SearchIcon from '../../assets/icons/search.svg?react';
import { Input } from '../Input';

interface MobileFilterDisplayNameProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export function MobileFilterDisplayName({
  value,
  onChange,
  label = 'Machine Name',
}: MobileFilterDisplayNameProps) {
  const hasValue = value.length > 0;

  return (
    <div className='flex flex-col gap-2'>
      <label className='size-p2 text-secondary font-medium'>{label}</label>
      <div className='relative'>
        <span
          className='text-disabled pointer-events-none absolute top-1/2 left-2
            flex h-4 w-4 -translate-y-1/2 items-center justify-center
            [&_path]:fill-current [&_svg]:fill-current'
        >
          <SearchIcon />
        </span>
        <Input
          type='text'
          placeholder='Search...'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          variant={hasValue ? 'default' : 'inactive'}
          className='w-full pl-8'
        />
      </div>
    </div>
  );
}

interface MobileFilterSelectProps {
  label: string;
  children: ReactNode;
}

export function MobileFilterSelect({
  label,
  children,
}: MobileFilterSelectProps) {
  return (
    <div className='flex flex-col gap-2'>
      <label className='size-p2 text-secondary font-medium'>{label}</label>
      <div className='w-full min-w-0'>{children}</div>
    </div>
  );
}
